import styled from "@emotion/styled";
import { FaQuestion } from 'react-icons/fa'

export const PokeImageSkeleton = styled(FaQuestion)`
    color: #ffca09;
    font-size: 64px;
`